import { RefreshCcw } from "lucide-react";
import CoupleRow from "./CoupleRow";
import Pagination from "./Pagination";
import AdminSearchBar from "./AdminSearchBar";

const CouplesFormDataPanel = ({
  coupleSubTab,
  setCoupleSubTab,
  counts,
  couplesForTab,
  loadingC,
  reloadCouples,
  onStatus,
  onView,
  onConsultation,
  onDelete,
  pagination,
  query,
  onSearch,
}) => (
  <div data-testid="section-couples-form-data">
    <span className="font-accent text-[11px] tracking-[0.25em] text-[var(--ld-gold-deep)]">
      Submissions
    </span>
    <h2 className="font-serif-display mt-3 text-3xl sm:text-4xl text-[var(--ld-ink)] font-medium leading-tight">
      Couples Form data
    </h2>

    <div className="mt-6">
      <AdminSearchBar
        placeholder="Search by couple name, email, venue, wedding date…"
        initialValue={query || ""}
        onSearch={onSearch}
      />
    </div>

    {/* Sub-tabs: Pending / Approved / Rejected */}
    <div className="mt-8 flex items-center gap-1 border-b border-[var(--ld-border)]">
      {[
        { id: "pending", label: "Pending", count: counts?.pending ?? 0 },
        { id: "approved", label: "Approved", count: counts?.approved ?? 0 },
        { id: "rejected", label: "Rejected", count: counts?.rejected ?? 0 },
      ].map((t) => (
        <button
          key={t.id}
          type="button"
          data-testid={`couple-subtab-${t.id}`}
          onClick={() => setCoupleSubTab(t.id)}
          className={
            "px-5 py-3 text-[11px] tracking-[0.2em] uppercase border-b-2 -mb-px transition-colors " +
            (coupleSubTab === t.id
              ? "border-[var(--ld-gold-deep)] text-[var(--ld-ink)]"
              : "border-transparent text-[var(--ld-ink-muted)] hover:text-[var(--ld-ink)]")
          }
        >
          {t.label}
          <span className="ml-2 text-[10px] text-[var(--ld-ink-muted)]">
            {t.count}
          </span>
        </button>
      ))}
    </div>

    <div className="flex items-center justify-between mt-6 mb-3">
      <p className="text-xs text-[var(--ld-ink-muted)]">
        {coupleSubTab === "rejected" ? (
          <>
            Rejected sign-ups are kept here. Use{" "}
            <strong>Restore</strong> to move them back to pending.
          </>
        ) : coupleSubTab === "approved" ? (
          <>
            Approved couples have been onboarded. Schedule consultations via the date picker.
          </>
        ) : (
          <>
            New sign-ups land here. Approve to onboard, or reject to archive.
          </>
        )}
      </p>
      <button
        onClick={reloadCouples}
        className="inline-flex items-center gap-1.5 text-[10px] tracking-[0.2em] uppercase text-[var(--ld-ink-muted)] hover:text-[var(--ld-ink)]"
      >
        <RefreshCcw size={12} strokeWidth={1.6} />
        Refresh
      </button>
    </div>
    <div className="border border-[var(--ld-border)] overflow-x-auto">
      <table className="w-full text-left">
        <thead className="bg-[var(--ld-ivory-warm)]/50">
          <tr className="text-[10px] tracking-[0.18em] uppercase text-[var(--ld-ink-muted)]">
            <th className="py-3 px-4">Couple</th>
            <th className="py-3 px-4">Wedding date</th>
            <th className="py-3 px-4">Services</th>
            <th className="py-3 px-4">Last sign-in</th>
            <th className="py-3 px-4">Status</th>
            <th className="py-3 px-4">Consultation</th>
            <th className="py-3 px-4 text-right">Actions</th>
          </tr>
        </thead>
        <tbody>
          {loadingC && (
            <tr>
              <td colSpan={7} className="py-8 text-center text-sm text-[var(--ld-ink-muted)]">
                Loading…
              </td>
            </tr>
          )}
          {!loadingC && couplesForTab.length === 0 && (
            <tr>
              <td colSpan={7} className="py-10 text-center text-sm text-[var(--ld-ink-muted)]">
                {coupleSubTab === "rejected"
                  ? "No rejected sign-ups."
                  : coupleSubTab === "approved"
                  ? "No approved couples yet."
                  : "No pending sign-ups."}
              </td>
            </tr>
          )}
          {couplesForTab.map((row) => (
            <CoupleRow
              key={row.id}
              row={row}
              mode={coupleSubTab}
              onStatus={onStatus}
              onView={onView}
              onConsultation={onConsultation}
              onDelete={onDelete}
            />
          ))}
        </tbody>
      </table>
    </div>
    {pagination && (
      <Pagination
        page={pagination.page}
        pageSize={pagination.pageSize}
        total={pagination.total}
        onPageChange={pagination.onPageChange}
        loading={pagination.loading}
      />
    )}
  </div>
);

export default CouplesFormDataPanel;
